import { GetRequestCachedV3, PostRequestCachedV3 } from "../../common/api"
import { urls } from "../../common/constants"
import { API_CACHE_DURATION } from "../../common/constants"

export const getBranches = async (data) => {
    const res = await GetRequestCachedV3(urls.getBranchList, data, true, API_CACHE_DURATION)
    if (res.status === 'Success') {
        return res.Data.Table.filter((el) => [2, 3].includes(el.BranchTypeID))
    } else {
        return []
    }
}
export const getCityDistance = async (data, isCache = false, cacheDuration = API_CACHE_DURATION) => {
    const res = await GetRequestCachedV3(urls.GetCityDistance, data, isCache, cacheDuration)
    if (res.status === 'Success') {
        const { Data: { Table: [{ Distance = 0 } = {}] = [] } = {} } = res || {}
        return Distance
    } else {
        return 0
    }
}

export const getUserList = async (data, isCache = false, cacheDuration = API_CACHE_DURATION) => {
    const res = await PostRequestCachedV3(urls.getUserList, data, isCache, cacheDuration)
    if (res.status === 'Success') {
        return res.Data.Table
    } else {
        return []
    }
}
    